import React, { FC } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { PartnerType } from 'Admin/Partners';
import { GET_ROLES_BY_PARTNER_QUERY } from 'Admin/Users/graphql';
import { UserType } from 'Admin/Users/types';

import { SystemRolesType, UserRoles } from './UserRoles';

export const UserRolesWrapper: FC<{
  currentPartner?: Partial<PartnerType>;
  currentUser?: Partial<UserType>;
  disabled?: boolean;
}> = ({ currentPartner, currentUser, disabled = false }) => {
  const { data: roles } = useQuery<SystemRolesType>(
    GET_ROLES_BY_PARTNER_QUERY,
    {
      variables: {
        partnerId: currentPartner?.id,
      },
      fetchPolicy: 'network-only',
    }
  );

  return (
    <UserRoles
      roles={roles?.systemRoles ?? []}
      currentUser={currentUser}
      currentPartner={currentPartner}
      disabled={disabled}
    />
  );
};
